import { z } from 'zod/v3';
import { transformNullish } from '../../common/utils';
import { zIsoDateTime } from '../../common/utils/schema/zIsoDateTime';

export const InputProcessingErrorSchema = z.object({
  description: transformNullish(z.string(), ''),
  dataObjectDescriptionCode: transformNullish(z.string(), ''),
  dataObjectDescriptionName: transformNullish(z.string(), ''),
  dataSubjectCode: transformNullish(z.string(), ''),
  dataSubjectName: transformNullish(z.string(), ''),
  createdAt: zIsoDateTime().nullish(),
  errorTypeCode: z.string().nullable(),
  errorCode: z.string().nullish(),
  errorArgs: z.record(z.unknown()).nullish(),
});
